import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthHTTPService } from 'src/app/modules/auth/_services/auth-http';
import { HotToastService } from '@ngneat/hot-toast';
import { ConfirmPasswordValidator } from './change-password-confirm.validator';
import { AuthService } from 'src/app/modules/auth';
import { Observable, of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  language: any;
  hasError: boolean;
  ErrorMessage: string;
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  changePasswordForm: UntypedFormGroup;
  isLoading$: Observable<boolean>;
  @Input() roles: any[];
 
  constructor(private translationService: TranslationService, private authService: AuthService,
     private toast: HotToastService,
    public modal: NgbActiveModal, private fb: UntypedFormBuilder,) { this.isLoading$ = this.authService.isLoading$; }
  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
    this.initForm();
  }
  onNoClick(): void {
    this.modal.close();
  }
  get ChangePwdForm() {
    return this.changePasswordForm.controls;
  }
  initForm() {
    this.changePasswordForm = this.fb.group({
      OldPassword:['', Validators.required],
      NewPassword: ['', [Validators.required,Validators.minLength(6),Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.{6,})/)]],
      ConfirmPassword: ['', Validators.required],
    }, {
      validator: ConfirmPasswordValidator.MatchPassword,
    });
  }
  submit() {
    this.changePasswordForm.markAllAsTouched();
    if (!this.changePasswordForm.valid) {
      return;
    }
    this.authService.showLoader();
    let TokenRequestModel = {
      //PassportNo : this.PassportNo,
      Password : this.ChangePwdForm.OldPassword.value,
      NewPassword : this.ChangePwdForm.ConfirmPassword.value
    }
    if (this.roles.includes('Staff'))
    {
      this.ChangePasswordForStaff(TokenRequestModel);
    }
    else
    {
      this.ChangePasswordForUser(TokenRequestModel);
    }
   
  }
 
  ChangePasswordForUser(TokenRequestModel)
  {
    const Subscr = this.authService.ChangePassword(TokenRequestModel).pipe(
      catchError((errorMessage) => {
        return of(errorMessage);
      })
    ).subscribe(res => {
      if (res.isSuccess && res.responseCode == 200) {
        this.toast.success("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.authService.hideLoader();
        this.onNoClick();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.toast.warning("<b>" + res.error?.message + "</b>", { style: { padding: '20px' } });
        this.authService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.authService.hideLoader();

      }
      else {
        if (this.language == "ar") {
          this.ErrorMessage = "رقم الهوية أو كلمة المرور غير صحيحة";
        }
        else {
          this.ErrorMessage = "National ID / Iqama or Password is incorrect";
        }
        this.authService.hideLoader();

      }
    });
    this.unsubscribe.push(Subscr);
  }
  ChangePasswordForStaff(TokenRequestModel)
  {
    const Subscr = this.authService.ChangePasswordForStaff(TokenRequestModel).pipe(
      catchError((errorMessage) => {
        return of(errorMessage);
      })
    ).subscribe(res => {
      if (res.isSuccess && res.responseCode == 200) {
        this.toast.success("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.authService.hideLoader();
        this.onNoClick();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.toast.warning("<b>" + res.error?.message + "</b>", { style: { padding: '20px' } });
        this.authService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.authService.hideLoader();

      }
      else {
        if (this.language == "ar") {
          this.ErrorMessage = "الرقم الشخصي أو كلمة المرور غير صحيحة";
        }
        else {
          this.ErrorMessage = "Personal number or Password is incorrect";
        }
        this.authService.hideLoader();

      }
    });
    this.unsubscribe.push(Subscr);
  }
  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.changePasswordForm.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }
  isControlInvalid(controlName: string): boolean {
    const control = this.changePasswordForm.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }
  controlHasError(validation: string, controlName: string) {
    const control = this.changePasswordForm.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }
  isControlTouched(controlName: string): boolean {
    const control = this.changePasswordForm.controls[controlName];
    return control.dirty || control.touched;
  }
}
